import { default as Books } from './Books';

export default Books;
